import getProductListSlice from "./getProductListSlice";

export const allHeaderSlices = {
  getProductList: getProductListSlice,
  //getNotification: getNotificationSlice,
};
